import './list-vehicle-transaction.scss';

import { LocalRole } from '@core/model/local-role.enum';
import { useUserIdentityContext } from '@core/services/user-identity.context';
import { GetVehicleTransactionModel } from "@factory/model/query-model-vehicle-transaction";
import { useQyGetVehicleTransaction } from "@factory/query/vehicle-transaction.query";
import { TableSort } from "@shared/models/table-sort";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderContent from '@shared/ui/header-content/header-content';
import SearchInput from "@shared/ui/search-input/search-input";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { currencyFormat } from '@shared/utility/formats/currency-format';
import { Button } from "primereact/button";
import { Column } from 'primereact/column';
import { DataTable, DataTableStateEvent } from 'primereact/datatable';
import { Paginator, PaginatorPageChangeEvent } from 'primereact/paginator';
import { Sidebar } from "primereact/sidebar";
import { useState } from "react";
import { CiSearch } from "react-icons/ci";
import { MdClear } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";

import { FilterVehicleTransaction } from "../filter-vehicle-transaction/filter-vehicle-transaction";
import { useFilterVehicleTransactionContext } from "../filter-vehicle-transaction/filter-vehicle-transaction.context"

interface ListVehicleTransactionProps {
  showCustomerVehicle?: false;
}
export function ListVehicleTransaction({ showCustomerVehicle }: ListVehicleTransactionProps) {
  // THIS IS THE LOCAL DECLARATION
  const navigate = useNavigate();
  const [rowLimit, setRowLimit] = useState(20);
  const [pageNumber, setPageNumber] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [first, setFirst] = useState(0);    
  const [tableSort, setTableSort] = useState<TableSort>({
    sortField: undefined,
    sortOrder: undefined,
  });  
  const [sort, setSort] = useState({});
  const [filterPanel, setFilterPanel] = useState(false);
  const { filterChipsElement, getFilterEntityValues, applyFilter } = useFilterVehicleTransactionContext();
  const { getUserRole } = useUserIdentityContext();
  const userRole = getUserRole().name;
  const { vehicleId } = useParams();

  // THIS IS THE QUERY DECLARATION
  const {
    data: vehicleTransactionResponse,
    isLoading,
    isError,
    error,
  } = useQyGetVehicleTransaction(
    searchTerm,
    rowLimit,
    pageNumber,
    sort,
    {...getFilterEntityValues(), vehicle: vehicleId || "" }
  );

  // THIS IS THE LOCAL DECLARATION
  const handleSearch = (searchTerm: string) => {
    setSearchTerm(searchTerm);
  };
  const handleTableSort = (e: DataTableStateEvent) => {
    setTableSort({
      sortField: e.sortField,
      sortOrder: e.sortOrder,
    });
    const order = e.sortOrder === 1 ? "ASC" : "DESC";
    setSort({ [e.sortField]: order });
  };
  const navigateToRecord = (item: GetVehicleTransactionModel) => {
    // navigate(`${item.code}`);
  };
  const onPageChange = (event: PaginatorPageChangeEvent) => {
    const offsetValue = event.page * rowLimit;
    setFirst(event.first);
    setPageNumber(offsetValue);
    setRowLimit(event.rows);
  };
  const handleNew = () => {
    navigate(`new`);
  };

  // THIS IS THE LOCAL RENDERS
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection title="Error Occured" message={(error as any)?.message} />
    </div>
  );
  const filterElement = (
    <section>
      <div className="flex gap-4 items-center mb-2">
        <SearchInput
          clearIcon={<MdClear />}
          searchIcon={<CiSearch />}
          searchTerm={searchTerm}
          onSearch={handleSearch}
          placeholder="Search items"
          className="w-full block"
        />
        <Button
          label="Filter"
          severity="secondary"
          badgeClassName="p-badge-danger"
          onClick={() => setFilterPanel(true)}
          outlined
        />
      </div>

      {filterChipsElement}
      <Sidebar visible={filterPanel} onHide={() => setFilterPanel(false)}>
        <FilterVehicleTransaction />
      </Sidebar>
    </section>
  );
  const grid = (
    <section className="mt-6">
      <h5 className="mb-2">
        Total Transactions: <b>{ vehicleTransactionResponse?.count }</b>
      </h5>

      <DataTable
        value={ vehicleTransactionResponse?.data }
        selectionMode="single"
        onSelectionChange={(e) => navigateToRecord(e.value)}
        onSort={handleTableSort}
        sortField={tableSort.sortField}
        sortOrder={tableSort.sortOrder}
      >
        <Column field="transaction_amount" header="Transaction Amount" sortable 
          body={(item) => (<>{currencyFormat(item?.transaction_amount || 0, "PHP")}</>)}
        ></Column>
        <Column field="transaction_points" header="Points" sortable></Column>
        <Column field="transaction_stamp" header="Stamp" sortable></Column>
        <Column field="transaction_remarks" header="Remarks" sortable></Column>
      </DataTable>

      <Paginator
        first={first}
        rows={rowLimit}
        totalRecords={ vehicleTransactionResponse?.count}
        rowsPerPageOptions={[10, 20, 30]}
        onPageChange={onPageChange}
      />
    </section>
  );

  return (
    <div id="ListVehicleTransaction" className="vehicle-transaction">

       <div className="p-7">
        {userRole !== LocalRole.CardOwner && filterElement}
        {isLoading && displayLoading}
        {isError && !isLoading && displayError}
        {!isLoading && !isError && grid}
      </div>
    </div>
  );
}

export default ListVehicleTransaction;
